import React, { useCallback, useContext, useMemo } from 'react';
import { Option } from 'kingpin/atoms/ContextMenu';
import { UIVersionContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';
import AccountPickerContext from '../../../contexts/AccountPickerContext';
import CurrentUserContext from '../../../contexts/CurrentUserContext';
import RolesContext from '../../../contexts/RolesContext';
import ToastContext from '../../../contexts/ToastContext';
import PERMISSIONS from '../../../permissionDefinitions';
import getTimeStamp from '../../../getTimeStamp';
import STORE from '../../../store';

const V3UnpublishScorecard = ({
  scorecard,
}: {
  scorecard: Scorecards.Scorecard;
}) => {
  const { showToast } = useContext(ToastContext);
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { id: currentUserId } = useContext(CurrentUserContext);
  const { currentPermissions } = useContext(RolesContext);
  const { isV3 } = useContext(UIVersionContext);

  const isOptionAvailable = useMemo(() => {
    if (!isV3) {
      return false;
    }

    if (!scorecard.isV3Published) {
      return false;
    }

    if (
      currentPermissions.includes(
        PERMISSIONS.CONTENT_ACCESS.SET_ANY_AVAILABLE_TO_PRIVATE,
      )
    ) {
      return true;
    }

    if (currentUserId === scorecard.createdBy) {
      return true;
    }

    return false;
  }, [
    currentPermissions,
    currentUserId,
    isV3,
    scorecard.createdBy,
    scorecard.isV3Published,
  ]);

  const onUnpublishClicked = useCallback(() => {
    const newScorecard: Scorecards.Scorecard = {
      ...scorecard,
      isV3Published: false,
      updatedBy: currentUserId,
      updatedOn: getTimeStamp(),
    };

    STORE.visualisations
      .getScorecardsRef({
        accountId: selectedAccountId,
      })
      .doc(scorecard.id)
      .set(newScorecard)
      .then(() => {
        showToast(`"${scorecard.title}" has been unpublished successfully!`);
      });
  }, [currentUserId, scorecard, selectedAccountId, showToast]);

  if (!isOptionAvailable) {
    return null;
  }

  return <Option label={'Unpublish'} onClick={onUnpublishClicked} />;
};

export default V3UnpublishScorecard;
